import request from '@/utils/request'

/**
 * 获取服务提供列表
 * @param {Object} params 查询参数
 * @returns {Promise} 包含服务提供列表的Promise对象
 */
export function listServiceProvides(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/serviceProvide.listServiceProvides',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 更新服务提供
 * @param {Object} data 更新数据
 * @returns {Promise} 包含更新结果的Promise对象
 */
export function updateServiceProvide(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/serviceProvide.updateServiceProvide',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除服务提供
 * @param {Object} data 删除数据
 * @returns {Promise} 包含删除结果的Promise对象
 */
export function deleteServiceProvide(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/serviceProvide.deleteServiceProvide',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}